module.exports = __webpack_public_path__ + "static/media/Header-Logo.4a93a515.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Header-Logo.png
// module id = 272
// module chunks = 0